module.exports = __webpack_public_path__ + "static/media/warner_sm.d5913926.jpg";